module.exports = __webpack_public_path__ + "img/gallery_7.068fdb29.jpg";